export default __webpack_public_path__ + "static/media/998.843c8574.gif";